import type { IconDefinition } from "@awesome.me/kit-3777c2145e/icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { addParameterToURL } from "bm-ui-kit";
import type { Variant } from "../type";

interface MobileMenuTileItemProps {
	title: string;
	url: string;
	icon: IconDefinition;

	variant: Variant;
}

export const MobileMenuTileItem = ({ icon, title, url, variant }: MobileMenuTileItemProps) => {
	return (
		<div
			key={`m_${title}`}
			className="bg-white position-relative shadow rounded-sm p-2 text-center font-weight-bold"
		>
			<FontAwesomeIcon icon={icon} className="bg-primary text-white rounded-lg p-2 mb-1" fixedWidth />
			<br />
			<a
				className="stretched-link text-dark h6 mb-0"
				href={addParameterToURL(url, {
					link_type: `${variant}-mosaic-mobile-menu-item`,
				})}
				role="menuitem"
			>
				{title}
			</a>
		</div>
	);
};
